import { useOrganization } from "../contexts/OrganizationContext.tsx";

/**
 * Organization feature flags. Keys mirror the backend catalog in
 * `svc-backend/src/scaleupxq/organizations/feature_flags.py`; only global admins
 * and developers switch them, on the organization's page.
 */
export const FEATURE_MICRO_APPS = "micro_apps";

/** Whether the currently selected organization has the feature switched on. */
export function useOrgFeature(key: string): boolean {
  const { currentOrg } = useOrganization();
  return !!currentOrg?.features?.includes(key);
}
